"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const addTeamMemberConstants = {
  USEREMAIL: 'email',
  SELECT_APP_ROLE_PLACEHOLDER: 'Select app role',
  SELECT_APP_ROLE_TITLE: 'SELECT APP ROLE',
  SELECT_MINE_SITES_TITLE: 'ASSIGN USERS TO <MineSiteLabel>',
  SELECT_MINE_SITES_PLACEHOLDER: 'Add Team members to <MineSiteLabel> and role',
  ADD_TEAM_MEMBERS_TO_MINE_SITE_AND_ROLE: 'ADD TEAM MEMBERS TO <MineSiteLabel> AND ROLE',
  REQUIRED: 'Required',
  PRIMARY: 'primary',
  MEDIUM: 'medium',
  NOT_FOUND: 'Creating new user'
};
var _default = exports.default = addTeamMemberConstants;